import { GetTransactionsParams } from "@/api/transactions";

export const transactionKeys = {
	balance: () => ["account_balance"] as const,
	list: (query: GetTransactionsParams) => ["kashuTransactions", query],
	all: () => ["kashuTransactions"] as const,
};
